import { initIDB } from "./";

export const indexedDbUpdate = (
  dbName: string,
  data: any,
  key?: IDBValidKey,
) => {
  return new Promise((resolve, reject) => {
    initIDB().then((db: any) => {
      const txn = db.transaction(dbName, "readwrite");
      const store = txn.objectStore(dbName);
      const query = store.put(data, key as any);
      query.onsuccess = function (event: Event) {
        resolve(event);
      };
      query.onerror = function (event: Event) {
        reject(event);
      };
      txn.oncomplete = function () {
        db.close();
      };
    });
  });
};
